var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('AppBar'),(_vm.isAdmin)?_c('AppSideBar'):_vm._e(),(_vm.isStoreKeeper)?_c('AppProducerSideBar'):_vm._e(),(_vm.isAffiliate)?_c('AppAffiliateSideBar'):_vm._e(),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1),_c('StoreSelector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }